var exports = {
  "t": "DataDeletionTab.module__deleteSection___RGl0cW",
  "i": "DataDeletionTab.module__warningText___RGl0cW",
};

module.exports = exports;
